export class Resource {
    public ResourceId: number = -1;
    public ResourceTypeId: number = -1;
    public ResourceName: string = "";
    public UID: string = "";
    public Active: boolean = false;
    public Branch: number = -1;
    public Selected: boolean = false;
    public WaitTime: number = 0;
    public StartTime: Date = null;
    public SkinTypeDisclaimerRequired: boolean = false;
    public SafetyPolicyDisclaimerRequired: boolean = false;
    public DisclaimerCode: string = "";
    public NetworkId: number = -1;
    public MinimumAge: number;
    public ColourHex: string;
    public CustomText: string = "Custom Text";
    public Selectable: boolean = true;
    public Unavailable: boolean = false;
    public AbsoluteTotal:number =0;
    public RunningTotal:number =0;
    public State: string = "";
    public LastDeepCleanDateTime: Date = null;
    public AppointmentsSinceLastDeepClean: number = 0;

    public static CreateFrom(r: any): Resource {        
        if (!r)
            return null;
        var resource: Resource = new Resource();
        resource.ResourceName = r.ResourceName;
        resource.ResourceId = r.ResourceId;
        resource.Active = r.Active;
        resource.Branch = r.Branch;
        resource.ResourceTypeId = r.ResourceTypeId;
        resource.Selected = false;
        resource.WaitTime = r.WaitTime || 0;
        resource.StartTime = r.StartTime;
        resource.NetworkId = r.NetworkId;

        resource.SkinTypeDisclaimerRequired = r.SkinTypeDisclaimerRequired;
        resource.SafetyPolicyDisclaimerRequired = r.SafetyPolicyDisclaimerRequired;
        resource.MinimumAge = r.MinimumAge;
        resource.DisclaimerCode = r.DisclaimerCode;
        resource.ColourHex = r.ColourHex;
        resource.Unavailable = r.Unavailable;
        resource.State = r.State || "";
        resource.RunningTotal = r.RunningTotal;

        return resource;
    }

    public static CreateFrom2(r: any): Resource {        
        if (!r)
            return null;
        var resource: Resource = new Resource();
        resource.ResourceName = r.Name;
        resource.ResourceId = r.Id;
        resource.Active = r.Active;
        resource.Branch = r.Branch;
        resource.ResourceTypeId = r.ResourceType;               
        resource.NetworkId = r.NetworkDeviceId;
        resource.ColourHex = r.ColourHex;
        resource.RunningTotal = r.RunningTotal;
        resource.AbsoluteTotal = r.AbsoluteTotal;
        resource.LastDeepCleanDateTime = r.LastDeepCleanDateTime
        resource.AppointmentsSinceLastDeepClean = r.AppointmentsSinceLastDeepClean
        resource.State = r.State || "";

        return resource;
    }

    constructor() {        
    }

    public Reset() {
        this.ResourceId = -1;
        this.ResourceName = "";
        this.ResourceTypeId = -1;
        this.UID = "";
        this.Active = false;
        this.Selected = false;
        this.Branch = -1;
        this.WaitTime = 0;
        this.StartTime = null;
        this.SkinTypeDisclaimerRequired = false;
        this.SafetyPolicyDisclaimerRequired = false;
        this.DisclaimerCode = "";
        this.NetworkId = -1;
        this.MinimumAge = undefined;
        this.State = "";
    }
};

export class Session {
    static CreateFromProduct(r: any): Session {
        if (!r)
            return null;
        var session: Session = new Session();
        session.SessionName = r.Description;
        session.SessionId = r.Id;
        session.ResourceTypeId = r.ResourceType;
        session.RetailPrice = r.RetailPrice;
        session.Selected = false;
        session.Active = r.Active;
        session.Branch = r.Branch;
        session.AllowPurchase = r.AllowPurchase;
        session.DecrementCredits = r.DecrementCredits;
        session.SessionCreditSystemLink = r.SessionCreditSystemLink;
        session.CreditSystemsList = r.CreditSystemsList;
        session.Duration = r.Duration;
        session.AllowOnlineReservation = r.AllowOnlineReservation;
        session.Deposit = r.Deposit;
        session.ProductCategory = r.ProductCategory;
        session.ProductCategoryIdList = r?.ProductCategoryIdList;
        session.ProductCategoryLink = r.ProductCategoryLink;
        session.ProductCategoryList = r.ProductCategoryList;
        return session;
    }

    public SessionId: number = -1;
    public SessionName: string = "";
    public Selected: boolean = false;
    public RetailPrice: number = 0.0;
    public Branch: number = -1;
    public Active: boolean = false;
    public ResourceTypeId: number = -1;
    public AllowPurchase: boolean = false;
    public DecrementCredits: number = 0;
    public Duration: number = 0;
    public SessionCreditSystemLink: SessionCreditSystemLink[];
    public CreditSystemsList: string = "";
    public AllowOnlineReservation: boolean = true;
    public Deposit: number = 0;
    public ProductCategory: number = -1;
    public ProductCategoryIdList: string = "";
    public ProductCategoryLink: ProductCategoryLink[];
    public ProductCategoryList: string = '';

    public static CreateFrom(r: any): Session {
        if (!r)
            return null;
        var session: Session = new Session();
        session.SessionName = r.SessionName;
        session.SessionId = r.SessionId;
        session.ResourceTypeId = r.ResourceTypeId;
        session.RetailPrice = r.Price;
        session.Selected = false;
        session.Active = r.Active;
        session.Branch = r.Branch;
        session.AllowPurchase = r.AllowPurchase;
        session.DecrementCredits = r.DecrementCredits;
        session.SessionCreditSystemLink = r.SessionCreditSystemLink;
        session.CreditSystemsList = r.CreditSystemsList;
        session.Duration = r.Duration;
        session.AllowOnlineReservation = r.AllowOnlineReservation;
        session.Deposit = r.Deposit;
        session.ProductCategory = r.ProductCategory;
        session.ProductCategoryIdList = r?.ProductCategoryIdList;
        session.ProductCategoryLink = r.ProductCategoryLink;
        session.ProductCategoryList = r.ProductCategoryList;
        return session;
    }

    constructor() {
    }

    public Reset() {
        this.SessionId = -1;
        this.ResourceTypeId = -1;
        this.SessionName = "";
        this.Selected = false;
        this.RetailPrice = 0.0;
        this.Active = false;
        this.Branch = -1;
        this.AllowPurchase = false;
        this.DecrementCredits = 0;
        this.SessionCreditSystemLink = [];
        this.Branch = -1;
        this.AllowOnlineReservation = true;
        this.Deposit = 0;
        this.ProductCategory = -1;
        this.ProductCategoryLink = [];
        this.ProductCategoryList = '';
    }
};

export class SessionCreditSystemLink {
    Id: number = -1;
    CreditSystem: number = -1;
    ProductId: number = -1;
    DecrementCredits?: number = null;
}

export class CreditSystemLookupItem {
  Active: boolean;
  DecrementCredits?: number;
  ExpiryDays?: number;
  Selected: boolean;
  Text: string;
  Value: number;

  constructor(lookupItem: any) {
    this.Active = lookupItem?.Active || false;
    this.DecrementCredits = lookupItem?.DecrementCredits || null;
    this.ExpiryDays = lookupItem?.ExpiryDays || null;
    this.Selected = false;
    this.Text = lookupItem?.Text;
    this.Value = lookupItem?.Value;
  }
}

export class Course {
    public CourseId: number = -1;
    public CourseName: string = "";
    public Selected: boolean = false;
    public Price: number = 0.0;
    public Branch: number = -1;
    public Active: boolean = false;
    public AllowPurchase: boolean = false;
    public DelayExpiryUntilNextVisit: boolean = false;

    public static CreateFrom(r: Course): Course {
        if (!r)
            return null;
        var course: Course = new Course();
        course.CourseName = r.CourseName;
        course.CourseId = r.CourseId;
        course.Price = r.Price;
        course.Selected = false;
        course.Active = r.Active;
        course.Branch = r.Branch;
        course.AllowPurchase = r.AllowPurchase;
        course.DelayExpiryUntilNextVisit = r.DelayExpiryUntilNextVisit;
        return course;
    }

    constructor() {
    }

    public Reset() {
        this.CourseId = -1;
        this.CourseName = "";
        this.Selected = false;
        this.Price = 0.0;
        this.Active = false;
        this.Branch = -1;
        this.AllowPurchase = false;
        this.DelayExpiryUntilNextVisit = false;
    }
};


export class Voucher {
    public VoucherId: number = -1;
    public VoucherName: string = "";
    public Selected: boolean = false;
    public Price: number = 0.0;
    public Branch: number = -1;
    public Active: boolean = false;
    public AllowPurchase: boolean = false;

    public static CreateFrom(r: Voucher):Voucher {
        if (!r)
            return null;
        var voucher: Voucher = new Voucher();
        voucher.VoucherName = r.VoucherName;
        voucher.VoucherId = r.VoucherId;
        voucher.Price = r.Price;
        voucher.Selected = false;
        voucher.Active = r.Active;
        voucher.Branch = r.Branch;
        voucher.AllowPurchase = r.AllowPurchase;
        return voucher;
    }

    constructor() {
    }

    public Reset() {
        this.VoucherId = -1;
        this.VoucherName = "";
        this.Selected = false;
        this.Price = 0.0;
        this.Active = false;
        this.Branch = -1;
        this.AllowPurchase = false;
    }
};

export class ProductCategory {
    Id: number = -1;
    Description: string = '';
    Active: boolean = false;
}

export class ProductCategoryLink {
    Id: number = -1;
    ProductCategory: number = -1;
    ProductId: number = -1;
}

export class Discount
{
    public Id: number = -1;
    public Description: string = "";
    public DiscountPercentage :number = 0;
    public Active: boolean = false;    
    public DiscountValue: number = 0.0;

    public static CreateFrom(r: Discount): Discount {
        if (!r)
            return null;
        var discount: Discount= new Discount();
        discount.Description = r.Description;
        discount.Active= r.Active;
        discount.DiscountPercentage = r.DiscountPercentage;
        discount.DiscountValue = r.DiscountValue;
        discount.Id = r.Id;        
        return discount;
    }
}

export class Product {
    public ProductId: number = -1;
    public ProductName: string = "";
    public Selected: boolean = false;
    public Price: number = 0.0;
    public Branch: number = -1;
    public Active: boolean = false;
    public AllowPurchase: boolean = false;
    public IsVoucher : boolean=false;
    public CashValue: number =0.0;
    public BarCode: string = "";
    public ProductCategory: number = -1;
    public ProductCategoryIdList: string = "";
    public ProductCategoryLink: ProductCategoryLink[];
    public ProductCategoryList: string = '';
    public StockManaged: boolean = false;

    public static CreateFrom(r: Product): Product {
        if (!r)
            return null;
        var product: Product = new Product();
        product.ProductName = r.ProductName;
        product.ProductId = r.ProductId;
        product.Price = r.Price;
        product.Selected = false;
        product.Active = r.Active;
        product.Branch = r.Branch;
        product.AllowPurchase = r.AllowPurchase;
        product.IsVoucher = r.IsVoucher;
        product.CashValue = r.CashValue;
        product.BarCode = r.BarCode;
        product.ProductCategory = r.ProductCategory;
        product.ProductCategoryIdList = r.ProductCategoryIdList;
        product.ProductCategoryLink = r.ProductCategoryLink;
        product.ProductCategoryList = r.ProductCategoryList;
        product.StockManaged = r.StockManaged;
        return product;
    }

    static CreateFrom2(r: any): Product {
        if (!r)
            return null;
        var product: Product = new Product();
        product.ProductName = r.Description;
        product.ProductId = r.Id;
        product.ProductCategory = r.ProductCategory;
        product.ProductCategoryLink = r.ProductCategoryLink;
        product.ProductCategoryList = r.ProductCategoryList;
        product.Price = r.RetailPrice;
        product.Selected = false;
        product.Active = r.Active;
        product.Branch = r.Branch;
        product.AllowPurchase = r.AllowPurchase;
        product.IsVoucher = r.IsVoucher;
        product.CashValue = r.CashValue;
        product.BarCode = r.BarCode;
        product.StockManaged = r.StockManaged;
        return product;
    }

    constructor() {
    }

    public Reset() {
        this.ProductId = -1;
        this.ProductName = "";
        this.Selected = false;
        this.Price = 0.0;
        this.Active = false;
        this.Branch = -1;
        this.AllowPurchase = false;
        this.IsVoucher =false;
        this.CashValue=0.0;
        this.ProductCategory = -1;
        this.ProductCategoryLink = [];
        this.ProductCategoryList = '';
        this.StockManaged = false;
    }
};

